<template>
    <div class="analysisTable">
        <div class="analysisTable__header">
            <div class="analysisTable__header--icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="23" height="20" viewBox="0 0 23 20" fill="none">
                    <path
                        d="M14.3313 1L17.5436 6.62138M4.69458 6.62138L7.90673 1M19.5994 6.62138H2.63865C2.39776 6.61644 2.15893 6.6658 1.9397 6.76579C1.72046 6.86577 1.52653 7.01384 1.37226 7.19901C1.21798 7.38401 1.10748 7.6015 1.04857 7.83507C0.989823 8.0688 0.984251 8.31271 1.03249 8.54867L2.79929 17.3825C2.87428 17.7506 3.07617 18.081 3.3696 18.3157C3.66319 18.5505 4.0297 18.675 4.40545 18.6674H17.8326C18.2084 18.675 18.5749 18.5505 18.8685 18.3157C19.1619 18.081 19.3636 17.7506 19.4388 17.3825L21.2056 8.54867C21.2538 8.31271 21.2482 8.0688 21.1895 7.83507C21.1307 7.6015 21.0201 7.38401 20.8658 7.19901C20.7115 7.01384 20.5176 6.86577 20.2984 6.76579C20.0791 6.6658 19.8403 6.61644 19.5994 6.62138Z"
                        stroke="#44A561" stroke-width="2" stroke-linecap="round" />
                </svg>
            </div>
            <div class="analysisTable__header--title">Vendedor</div>
        </div>
        <div class="analysisTable__content" v-if="!isLoading">
            <div class="analysisTable__content--list">
                <div class="analysisTable__content--list-item">
                    <div class="item">
                        <div class="item__container">
                            <div class="item__container--title">Nome</div>
                            <div class="item__container--value">{{ name }}</div>
                            <div class="item__container--pill green">{{ client_id }}</div>
                        </div>
                    </div>
                </div>
                <div class="analysisTable__content--list-item">
                    <div class="item">
                        <div class="item__container">
                            <div class="item__container--title">Telefone</div>
                            <div class="item__container--value">{{ telefone }}</div>
                            
                        </div>
                    </div>
                </div>
                <div class="analysisTable__content--list-item">
                    <div class="item">
                        <div class="item__container">
                            <div class="item__container--title">Email</div>
                            <div class="item__container--value">{{ email }}</div>
                            
                        </div>
                    </div>
                </div>
                <div class="analysisTable__content--list-item no-border">
                    <div class="item">
                        <div class="item__container">
                            <div class="item__container--title">Cpf</div>
                            <div class="item__container--value">{{ cpf }}</div>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="row justify-content-center p-5">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    name: 'AnalysisTableSeller',
    props: {
        data: {
            type: Object,
            required: true
        },
        totalizer: {
            type: Object,
            required: false
        },
    },
    computed: {
        isLoading() {
            return this.$store.getters["getLoadingAnalysisSelldata"]
        },
        name() {
            return this.data && this.data.seller && this.data.seller.name ? this.data.seller.name : '---';
        },
        client_id() {
            return this.data && this.data.seller && this.data.seller.id ? '#' + this.data.seller.id : '---';
        },
        telefone() {
            return this.data && this.data.seller && this.data.seller.cellphone ? this.data.seller.cellphone : '---';
        },
        email() {
            return this.data && this.data.seller && this.data.seller.email ? this.data.seller.email : '---';
        },
        cpf() {
            return this.data && this.data.seller && this.data.seller.cpf_cnpj ? this.data.seller.cpf_cnpj : '---';
        },
        countTelefone() {
            if (!this.totalizer || !this.totalizer.count) {
                return 0
            }
            return this.totalizer && this.totalizer.counte && this.totalizer.count.phone ? this.totalizer.count.phone : '---';
        },
        countEmail() {
            if (!this.totalizer || !this.totalizer.count) {
                return 0
            }
            return this.totalizer && this.totalizer.count && this.totalizer.count.email ? this.totalizer.count.email : '---';
        },
        countCpf() {
            if (!this.totalizer || !this.totalizer.count) {
                return 0
            }
            return this.totalizer && this.totalizer.count && this.totalizer.count.cpf_cnpj ? this.totalizer.count.cpf_cnpj : '---';
        },

    },
};
</script>

<style scoped lang="scss">
.analysisTable {
    width: 100%;
    margin: 20px 0px 0px 0px;

    &__header {
        padding: 0px 20px;
        display: flex;
        justify-content: flex-start;

        &--icon {
            width: 20.698px;
            height: 20.698px;
            flex-shrink: 0;
        }

        &--title {
            color: #44A561;
            font-size: 18px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
            margin-left: 14px;
        }
    }

    &__content {
        height: auto;
        width: 100%;

        hr {
            background: #E5E5E5;
        }

        &--list {
            height: auto;
            width: 100%;
            margin: 20px 0px;

            .item {
                border-bottom: solid 1px #E5E5E5;
                position: relative;

                &__container {
                    padding: 20px;

                    &--title {
                        color: #B1B1B1;
                        font-size: 0.8em;
                        font-style: normal;
                        font-weight: 400;
                        line-height: normal;
                    }

                    &--value {
                        color: #141414;
                        font-size: 0.9em;
                        font-style: normal;
                        font-weight: 600;
                        line-height: normal;
                        width: calc(100% - 100px);
                        overflow-x: hidden;
                        // line-break: auto;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                    }

                    &--pill {
                        position: absolute;
                        right: 20px;
                        top: 30%;
                        width: auto;
                        font-size: 0.7em;
                        padding: 4px 10px;
                        font-size: 12px;
                        font-style: normal;
                        font-weight: 600;
                        line-height: normal;
                        border-radius: 50px;


                    }
                }

            }

            .no-border .item {
                border-bottom: none;
            }

        }
    }
}

.green {
    background: rgba(68, 165, 97, 0.10);
    color: #44A561;
}

.red {
    background: rgba(255, 95, 95, 0.10);
    color: #FF5F5F;
}
</style>